import axios from "src/lib/axios";

export const getCityInfo = () => {
  return axios.get(`/lalamove/cities`);
};

export const getLalamoveOrderInfo = (orderId) => {
  return axios.get(`/lalamove/order/${orderId}`);
};

export const getLalamoveDriverInfo = (orderId, driverId) => {
  return axios.get(`/lalamove/orders/${orderId}/drivers/${driverId}`);
};

// ? old
// export const getQuotationInfo = (info) => {
//   return axios.post(`/lalamove/quotation`, info);
// };

// export const placeOrder = (info) => {
//   return axios.post(`/lalamove/order`, info, {
//     headers: {
//       "Content-Type": "multipart/form-data", // do not forget this
//     },
//   });
// };

export const getQuotationInfo = (info) => {
  return axios.post(`/lalamove/quotation-check`, info);
};

export const placeOrder = (info) => {
  return axios.post(`/lalamove/quotation-request`, info);
};

export const cancelOrder = (orderId) => {
  return axios.delete(`/lalamove/order/${orderId}`);
};

export const updateSellerLocation = (info) => {
  return axios.post(`/lalamove/update-seller-location`, info);
};
